module.exports = __webpack_public_path__ + "static/img/alpha.2a802731.png";